import React, { useEffect, useState } from "react";
import api, { showAlert } from "../../util/api";

const AdminConstituency = () => {

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    const [form, setForm] = useState({
        local_government: "",
        constituency: "",
        ward: "",
        unit: "",
        town: "",
        state: "",
    });


    useEffect(() => {
        fetchConstituency();
    }, []);


    const fetchConstituency = async () => {

        try {

            const response = await api.get("/admin/constituency", {
                headers: {
                    Accept: "application/json",
                },
            })  ;

            const result =
                await response.data;


            if (result.success && result.data) {

                setForm({
                    local_government:
                        result.data.local_government || "",

                    constituency:
                        result.data.constituency || "",

                    ward:
                        result.data.ward || "",

                    unit:
                        result.data.unit || "",

                    town:
                        result.data.town || "",

                    state:
                        result.data.state || "",
                });
            }

        } catch (error) {

            console.error(error);

            setMessage(
                "Unable to load constituency information."
            );

        } finally {

            setLoading(false);
        }
    };


    const handleChange = (e) => {

        const {
            name,
            value
        } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);
        setMessage("");


        try {

            const response = await api.post("/admin/constituency", form);


            const result =
                await response.data;


            if (result.success === false) {

                throw new Error(
                    result.message ||
                    "Unable to update constituency."
                );
            }

            showAlert('success', 'success!', "Constituency updated successfully.");

            setMessage(
                "Constituency updated successfully."
            );

        } catch (error) {

            setMessage(
                error.message ||
                "Something went wrong."
            );

        } finally {

            setSaving(false);
        }
    };


    if (loading) {

        return (
            <div className="admin-page-loading">
                Loading constituency...
            </div>
        );
    }


    return (
        <div className="admin-constituency-page">

            <div className="admin-page-header">

                <div>

                    <span className="admin-page-eyebrow">
                        WEBSITE / CONSTITUENCY
                    </span>

                    <h2>
                        Constituency <em>Details.</em>
                    </h2>

                    <p>
                        Manage the official constituency
                        information and geographical
                        representation details.
                    </p>

                </div>


                <button
                    type="submit"
                    form="constituency-form"
                    className="admin-primary-button"
                    disabled={saving}
                >
                    {saving
                        ? "Saving..."
                        : "Save Changes"
                    }
                </button>

            </div>


            {message && (
                <div className="admin-form-message">
                    {message}
                </div>
            )}


            <form
                id="constituency-form"
                onSubmit={handleSubmit}
            >

                <section className="admin-panel">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                REPRESENTATION
                            </span>

                            <h3>
                                Constituency Information
                            </h3>

                        </div>

                    </div>


                    <div className="admin-form">

                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Local Government
                                </label>

                                <input
                                    name="local_government"
                                    value={
                                        form.local_government
                                    }
                                    onChange={handleChange}
                                    placeholder="Irepodun / Ifelodun"
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Constituency
                                </label>

                                <input
                                    name="constituency"
                                    value={
                                        form.constituency
                                    }
                                    onChange={handleChange}
                                    placeholder="Irepodun / Ifelodun I"
                                />

                            </div>

                        </div>


                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Ward
                                </label>

                                <input
                                    name="ward"
                                    value={form.ward}
                                    onChange={handleChange}
                                    placeholder="05 — Igede I"
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    Unit
                                </label>

                                <input
                                    name="unit"
                                    value={form.unit}
                                    onChange={handleChange}
                                    placeholder="01"
                                />

                            </div>

                        </div>


                        <div className="admin-form-row">

                            <div className="admin-form-group">

                                <label>
                                    Town
                                </label>

                                <input
                                    name="town"
                                    value={form.town}
                                    onChange={handleChange}
                                    placeholder="Igede-Ekiti"
                                />

                            </div>


                            <div className="admin-form-group">

                                <label>
                                    State
                                </label>

                                <input
                                    name="state"
                                    value={form.state}
                                    onChange={handleChange}
                                    placeholder="Ekiti State"
                                />

                            </div>

                        </div>

                    </div>

                </section>


                {/* PREVIEW */}

                <section className="admin-panel admin-constituency-preview">

                    <div className="admin-panel-header">

                        <div>

                            <span>
                                PREVIEW
                            </span>

                            <h3>
                                Representation Summary
                            </h3>

                        </div>

                    </div>


                    <div className="admin-constituency-summary">

                        <div>

                            <span>
                                LOCAL GOVERNMENT
                            </span>

                            <strong>
                                {form.local_government ||
                                    "—"}
                            </strong>

                        </div>


                        <div>

                            <span>
                                CONSTITUENCY
                            </span>

                            <strong>
                                {form.constituency ||
                                    "—"}
                            </strong>

                        </div>


                        <div>

                            <span>
                                WARD
                            </span>

                            <strong>
                                {form.ward || "—"}
                            </strong>

                        </div>


                        <div>

                            <span>
                                UNIT
                            </span>

                            <strong>
                                {form.unit || "—"}
                            </strong>

                        </div>


                        <div>

                            <span>
                                TOWN
                            </span>

                            <strong>
                                {form.town || "—"}
                            </strong>

                        </div>


                        <div>

                            <span>
                                STATE
                            </span>

                            <strong>
                                {form.state || "—"}
                            </strong>

                        </div>

                    </div>

                </section>

            </form>

        </div>
    );
};

export default AdminConstituency;